import { logos } from "@/utils/logos";

function Carroussel() {
  return (
    <div className="relative w-full h-full flex overflow-hidden group">
      <div className="flex animate-scroll-logos group-hover:[animation-play-state:paused]">
        {/* First set of logos */}
        {logos.map((partner, index) => (
          <div
            key={index}
            className="flex-shrink-0 mx-3 flex items-center justify-center p-4 md:p-6 bg-white rounded-lg shadow-sm h-24 md:h-32 w-32 md:w-40"
          >
            <img
              src={partner.logo}
              alt={partner.name}
              className="max-w-[80px] max-h-[50px] md:max-w-[100px] md:max-h-[60px] object-contain"
            />
          </div>
        ))}
      </div>
      <div className="absolute top-0 flex animate-scroll-logos2 group-hover:[animation-play-state:paused]">
        {/* Duplicate set for seamless loop */}
        {logos.map((partner, index) => (
          <div
            key={`dup-${index}`}
            className="flex-shrink-0 mx-3 flex items-center justify-center p-4 md:p-6 bg-white rounded-lg shadow-sm h-24 md:h-32 w-32 md:w-40"
          >
            <img
              src={partner.logo}
              alt={partner.name}
              className="max-w-[80px] max-h-[50px] md:max-w-[100px] md:max-h-[60px] object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Carroussel;
